import React, { Component } from 'react';
import { arrayOf, string, shape, bool, func, object } from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import compact from 'lodash/compact';
import flatten from 'lodash/flatten';
import * as orgJobsActionCreators from '../../JobMatching/OrgJobsActions';
import * as rulesActionCreators from '../RulesActions';
import { areAllFacetsChecked, getQueryParams } from '../../../lib/facetHelpers';
import InPlaceIndicator from 'ps-components/LoadingIndicator/InPlaceIndicator/InPlaceIndicator';
import FacetPanel from 'ps-components/FacetPanel/FacetPanel';
import JobMatchingHeader from './JobMatchingHeader/JobMatchingHeader';
import JobMatchingListPanel from './JobMatchingListPanel/JobMatchingListPanel';
import Placeholder from 'ps-components/Placeholder/Placeholder';
import getHiddenFacets from 'ps-components/FacetPanel/getHiddenFacets';
import { jobFacetSearchActions } from '../../../reducers/modules/jobs/jobFacetSearch/jobFacetSearch';
import './JobMatchingSliderContainer.scss';
import { SLIDEOUTS } from '../../Slideout/Slideouts';
const STEP = 50;
class JobMatchingSliderContainer extends Component {
  static propTypes = {
    actions: object,
    hideSlideout: func,
    launchDarklyFeatureFlags: object,
    orgJobs: object,
    selectedRule: object,
    showSlideout: func,
    slideout: object,
    replacementTokens: arrayOf(
      shape({
        token: string,
        value: string
      })
    ),
    useJobCodeKey: bool
  };
  constructor(props) {
    super(props);
    this.state = {
      activePage: 1
    };
  }
  componentDidMount() {
    this.handleReset();
  }
  
  componentDidUpdate(prevProps, prevState) {
    const { actions, orgJobsIsSelected, slideout } = this.props;
    if (slideout.open && !prevProps.slideout.open) {
      actions.searchInputSearch('');
    }
    if (prevProps.slideout.open !== slideout.open && !slideout.open && prevProps.slideout.open) {
      this.handleReset();
      orgJobsIsSelected ? null : actions.toggleShowSelectedJobs();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { open } = this.props.slideout;
    const facetSearchInput = document.getElementById('facet__search matching__facets');
    if (open !== nextProps.slideout.open && !nextProps.slideout.open) {
      const { actions, orgJobsIsSelected } = this.props;
      actions.clearSelectedJobs();
      orgJobsIsSelected ? null : actions.toggleShowSelectedJobs();
      if (facetSearchInput) facetSearchInput.value = '';
      actions.setOrgJobFacetText('');
    }
  }

  applyToJobs = item => {
    const { actions, launchDarklyFeatureFlags, selectedOrgJobs, selectedRule, showSlideout } = this.props;
    const selectedJobIds = selectedOrgJobs.map(job => job.orgJobId);
    let strategy = 'ADD';
    if (item.includes('Overwrite All')) strategy = 'OVERWRITE_ALL';
    if (item.includes('Overwrite Applicable')) strategy = 'OVERWRITE_APPLICABLE';
    actions.applyRuleToJobs(selectedRule.id, selectedJobIds, strategy);
    showSlideout(SLIDEOUTS.JOB_MATCHING_RESULTS, { launchDarklyFeatureFlags: launchDarklyFeatureFlags });
  };

  hideSlideout = () => {
    const { actions, hideSlideout } = this.props;
    const facetSearchInput = document.getElementById('facet-search matching-facets');
    if (facetSearchInput) facetSearchInput.value = '';
    hideSlideout();
  };

  pageOrgJobs = (first, newAfter) => {
    const { actions } = this.props;
    actions.pageList(first, newAfter);
  };

  searchBySelected = () => {
    const { actions } = this.props;
    actions.toggleShowSelectedJobs();
  };

  toggleJobSelected = id => {
    const { actions, jobFacetSearch } = this.props;
    actions.toggleJobSelected(id, jobFacetSearch.items);
  };

  handleReset = () => {
    const { actions, jobFacetSearch } = this.props;
    actions.search({
      params: getQueryParams(jobFacetSearch.name),
      clear: true
    });

    actions.setOrgJobFacetText('');
    this.setState({ activePage: 1 });
  };

  handlePageChange = newPage => {
    this.setState({ activePage: newPage });
    this.pageOrgJobs(STEP, STEP * newPage - STEP);
  };


  handleSearchChange = (newSearchText) => {
    const { actions, jobFacetSearch } = this.props;
    this.setState({ activePage: 1 });
    actions.search({
      params: {
        ...jobFacetSearch.lastQueryParams,
        offset: 0,
        es_query: newSearchText
      }
    });
  };

  render() {
    const {
      actions,
      selectedRule,
      orgJobsSearchText,
      useJobCodeKey,
      replacementTokens,
      jobFacetSearch,
      orgJobsIsSelected,
      selectedOrgJobs
    } = this.props;
    const { activePage } = this.state;
    const hasFacetItems = jobFacetSearch.facets
      .map(facet => facet.items)
      .reduce((memo, items) => memo.concat(items), []).length;
    const hasOrgJobs = jobFacetSearch.items.length;

    if (jobFacetSearch.loading && !hasOrgJobs && !hasFacetItems) {
      return <InPlaceIndicator />;
    }

    const hasSearchCriteria =
      compact(flatten(Object.values(jobFacetSearch.include))).length > 0 ||
      compact(flatten(Object.values(jobFacetSearch.exclude))).length > 0;

    if (!hasOrgJobs && !hasFacetItems && !hasSearchCriteria && jobFacetSearch.loaded) {
      return (
        <div className="result__details-container">
          <div className="details">
            <Placeholder
              className="pxl-text-small pxl-text-muted"
              imagePath="/view/static/mp/images/empty_results.svg"
              primaryText="No org jobs exist for this currency or group."
              secondaryText="Please select another currency or group."
              showText={true}
            />
          </div>
        </div>
      );
    }
    const showResetButton =
      areAllFacetsChecked(jobFacetSearch.facets, jobFacetSearch.facetSelection) ||
      (jobFacetSearch.lastQueryParams && jobFacetSearch.lastQueryParams.es_query !== '');

    return (
      <div className="job-matching__slideout">
        <JobMatchingHeader
          applyToJobs={this.applyToJobs}
          hideSlideout={this.hideSlideout}
          selectedJobs={selectedOrgJobs}
          selectedRuleName={selectedRule.name}
        />
        <div className="job-matching__body">
          <FacetPanel
            className="job-matching__facets"
            facetItemClick={actions.facetItemClick}
            facetReset={this.props.actions.facetReset}
            facets={jobFacetSearch.facets}
            facetSelection={jobFacetSearch.facetSelection}
            hiddenFacets={getHiddenFacets('jobMatchingSlider', useJobCodeKey)}
            isDisabled={!orgJobsIsSelected}
            isLoaded={jobFacetSearch.loaded}
            lastFacetFilteredID={jobFacetSearch.lastFacetFilteredID}
            limit={5}
            resetSearch={this.handleReset}
            showFacetSectionSearch={true}
            showResetButton={showResetButton}
            showZeros={jobFacetSearch.showZeros}
            title="Job Matching"
          />
          <JobMatchingListPanel
            isSelected={orgJobsIsSelected}
            orgJobs={jobFacetSearch.items}
            orgJobsTotalCount={jobFacetSearch.searchResultsCount}
            offset={jobFacetSearch.offset}
            pageOrgJobs={this.pageOrgJobs}
            searchBySelected={this.searchBySelected}
            selectedJobs={selectedOrgJobs}
            toggleJobSelected={this.toggleJobSelected}
            toggleSelectAllOrgJobs={actions.toggleSelectAllOrgJobs}
            searchText={orgJobsSearchText}
            setSearchText={actions.setOrgJobFacetText}
            search={this.handleSearchChange}
            selectAllFilteredJobs={actions.selectAllFilteredJobs}
            replacementTokens={replacementTokens}
            useJobCodeKey={useJobCodeKey}
            clearJobsOnly={actions.clearJobsOnly}
            searchCriteria={jobFacetSearch.lastQueryParams}
            handlePageChange={this.handlePageChange}
            activePage={activePage}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ orgJobs, slideout, rules, session, jobFacetSearch }) => ({
  selectedOrgJob: orgJobs.selectedJob,
  orgJobsIsSelected: orgJobs.isSelected,
  orgJobsSearchText: orgJobs.searchText,
  selectedOrgJobs: orgJobs.selectedJobs,
  selectedRule: rules.selectedRule,
  slideout,
  replacementTokens: session.replacementTokens,
  useJobCodeKey: session.organization.useJobCodeKey,
  jobFacetSearch
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ ...orgJobsActionCreators, ...rulesActionCreators, ...jobFacetSearchActions }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(JobMatchingSliderContainer);